import { BE_API_URL } from './constants';

export const checkHealth = () => {
  return fetch(`${BE_API_URL}/api/healthcheck`)
    .then(response => response.json())
    .then(data => data.status)
    .catch(error => {
      console.error('Health check failed:', error);
      return false;
    });
};

export const getCategories = () => {
  return fetch(`${BE_API_URL}/api/money-lover/categories`)
    .then(response => response.json())
    .then(data => {
      const options = []
      data.map((cate) => {
        options.push({ value: cate.name, label: cate.name, id: cate.id })
      })
      return options;
    })
    .catch(error => {
      console.error(error);
      return [];
    });
}

